import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/css/app.scss'
import './assets/css/project.scss'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import 'vue-snotify/styles/material.css'
import jquery from 'jquery'
import underscore from 'vue-underscore'
import 'vue-loading-overlay/dist/vue-loading.css'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import VueWorker from 'vue-worker'
import StoreProcPlugin from './share/service/plugin/StoreProcPlugin'
import AppLibPlugin from './share/service/plugin/AppLibPlugin'
import { sync } from 'vuex-router-sync'
import VueClipboard from 'vue-clipboard2'
import ConstDef from './share/ConstDef'
import axios from 'axios'

VueClipboard.config.autoSetContainer = true // add this line
sync(store, router)

Vue.use(VueClipboard)
Vue.use(StoreProcPlugin)
Vue.use(AppLibPlugin)
Vue.use(VueWorker)
Vue.prototype.$Q = jquery
const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    timeout: 5000
  }
}
Vue.use(Snotify, options)
Vue.use(underscore)
Vue.config.productionTip = false

// global pipe
Vue.filter('comma', function (value) {
  if (value === undefined || value === null) return null
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})
Vue.filter('percent', function (value) {
  if (value === undefined || value === null) return null
  return `${value * 100}%`
})
Vue.filter('date', function (value) {
  if (value === undefined || value === null) {
    return
  }
  return value.toString().substring(0, 10)
})
Vue.filter('yyyyMMdd', function (value) {
  if (value === null) {
    return
  }
  let date = this.$_appLib.formatDateFromTimeStamp(value)
  let mm = parseInt(date.substring(5, 7))
  let dd = parseInt(date.substring(8, 10))
  return `${date.substring(0, 4)}년 ${mm}월 ${dd}일`
})
Vue.filter('MMdd', function (value) {
  if (value === null) {
    return
  }
  let date = this.$_appLib.formatDateFromTimeStamp(value)
  let mm = parseInt(date.substring(5, 7))
  let dd = parseInt(date.substring(8, 10))
  return `${mm}월 ${dd}일`
})
Vue.filter('yyyyMM', function (value) {
  if (value === null) {
    return
  }
  let date = this.$_appLib.formatDateFromTimeStamp(value)
  let mm = parseInt(date.substring(5, 7))
  return `${date.substring(0, 4)}년 ${mm}월`
})
Vue.filter('MM', function (value) {
  if (value === null) {
    return
  }
  let date = this.$_appLib.formatDateFromTimeStamp(value)
  let mm = parseInt(date.substring(5, 7))
  return `${mm}월`
})
Vue.filter('hyphenTelNo', function (value) {
  if (value.substring(0, 2) === '02') {
    if (value.length === 9) {
      return `${value.substring(0, 2)}-${value.substring(2, 5)}-${value.substring(5, 9)}`
    } else if (value.length > 9) {
      return `${value.substring(0, 2)}-${value.substring(2, 6)}-${value.substring(6, value.length)}`
    } else {
      return value
    }
  } else {
    if (value.length === 10) {
      return `${value.substring(0, 3)}-${value.substring(3, 6)}-${value.substring(6, 10)}`
    } else if (value.length > 10) {
      return `${value.substring(0, 3)}-${value.substring(3, 7)}-${value.substring(7, value.length)}`
    } else {
      return value
    }
  }
})

// axios 인터셉트
axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token')
    if (token !== undefined) {
      // // console.log('*********************',localStorage.getItem('token'))
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  }
)
axios.interceptors.response.use( // response => response, (error) => {
  function (response) {
    // // // console.log(response)
    return response
  },
  async function (error) {
    // // console.log('-----------------------',error.config)
    if (error.response.status === ConstDef.REFRESH_TOKEN) {
      await store.dispatch('tokenRefresh', error.config)
      console.log('refreshToken-----------------------', error.config)
      return axios.request(error.config)
    } else if (error.response === undefined) {
      alert('시스템 이상 잠시후 다시 접속 하세요')
      return Promise.reject(error)
    } else if (error.response.status === ConstDef.FORBIDDEN) {
      alert('권한 없음')
    } else if (error.response.status === ConstDef.UNAUTHORIZED) {
      router.replace('/')
    } else if (error.response.status === ConstDef.BAD_REQUEST || error.response.status === ConstDef.NOT_FOUND) {
      // // // console.log('others System Error')
      alert('시스템 이상(Erro Code:' + error.response.status + ')')
      return Promise.reject(error)
    } else if (error.response.data.status === ConstDef.DUPLICATE_LOGIN) {
      // //  response)
      alert(error.response.data.message)
      router.replace('/')
    } else {
      // // // console.log(error)
      return Promise.reject(error)
    }
  }
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
